<benefits-dialog [open]="true" [heading]="'ASSET_CHARGES.LINK_ASSET' | translate" [eyebrow]="'ASSET_CHARGES.TITLE' | translate" (closed)="closed.emit()">
  <div class="link-asset-dialog">
    <div class="field">
      <span class="field__label">{{ 'ASSET_CHARGES.ASSET' | translate }}</span>
      <app-asset-select (picked)="assetId.set($event)" />
    </div>
    @if (error(); as err) {
      <p class="wn-banner wn-banner--error" role="alert">{{ err }}</p>
    }
  </div>

  <ng-container benefitsDialogFooter>
    <button type="button" pButton [outlined]="true" [label]="'COMMON.CANCEL' | translate" (click)="closed.emit()"></button>
    <button type="button" pButton class="link-asset-dialog__confirm" icon="pi pi-link" [label]="'ASSET_CHARGES.LINK_ASSET' | translate" [disabled]="!valid() || saving()" (click)="confirm()"></button>
  </ng-container>
</benefits-dialog>
